import request from '@/utils/request'
import { formatParam } from '@/utils/tool'
import { BasicsType } from '@/api/type-api'
import { AdInfoType } from '@/api/type-res'

// 自定义Nav导航
export function topColumn (): any {
  return request('/saas/gtpw/product/topColumn', {
    method: 'GET'
  })
}

// 最热产品排行
export function hot (): any {
  return request('/saas/gtpw/product/hot', {
    method: 'GET'
  })
}

// 最新产品排行
export function newData (): any {
  return request('/saas/gtpw/product/new', {
    method: 'GET'
  })
}

// 首页-轮播广告
export function adInfo (params?: BasicsType): Promise<[AdInfoType]> {
  return request(`/saas/gtpw/product/adInfo?${formatParam(params)}`, {
    method: 'GET'
  })
}

// 首页-新进商户
export function userNew (): any {
  return request('/saas/gtpw/mchUser/userNew', {
    method: 'GET'
  })
}

// 首页推荐产品
export function reconnentList (params): any {
  return request(`/saas/gtpw/product/recommendList?${formatParam(params)}`)
}

// 首页-最赚产品排行
export function earn (): any {
  return request('/saas/gtpw/product/earn')
}
